import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

import { MoveTargetSourceRow } from './buildMoveTargets';

type Deps = {
  /** rowId → shift_id。deliveries 由来の解決を画面ごとに注入する */
  shiftIdOfRow: (rowId: string) => number | null;
  driverNameById: ReadonlyMap<number, string>;
};

/**
 * 「他車両へ配車」の候補行を作る。
 *
 * 乗務者名は行 (= 勤務) の driverId から引く。Vehicle.driverName は truck 単位に
 * 作られるため、1 台に 2 人が同じ時間帯で乗る勤務では候補が「同じ車両・同じ名前」の
 * 2 行になり、どちらの勤務へ移すのか読めない。
 */
export function buildMoveTargetRows(
  rowGroups: readonly VehicleRowGroup[],
  { shiftIdOfRow, driverNameById }: Deps,
): MoveTargetSourceRow[] {
  return rowGroups.flatMap((g) => g.rows.map((r) => ({
    rowId: r.rowId,
    vehicleNumber: g.vehicle.vehicleNumber,
    driverName: (r.driverId != null ? driverNameById.get(r.driverId) : undefined) ?? g.vehicle.driverName,
    shiftId: shiftIdOfRow(r.rowId),
    isPlaceholderRow: r.source.isPlaceholderRow,
  })));
}
